"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const Group_1 = __importDefault(require("../components/Group"));
const selectors_1 = require("../modules/selectors");
const derive_form_1 = require("../modules/derive-form");
const DynamicForm = ({ isReady, groups, dispatchers, fusions, renderers, passthroughProps, enableRulesets, renderInputs, formId, formIndex, wrappers: { FormWrapper, GroupWrapper, SubgroupWrapper, RepeatGroupWrapper, RepeatItemWrapper, }, }) => isReady ? (react_1.default.createElement(FormWrapper, { passthroughProps: passthroughProps }, groups.map(({ label, ...group }) => (react_1.default.createElement(Group_1.default, { ...group, label: label, key: label, fusions: fusions, renderers: renderers, passthroughProps: passthroughProps, Wrapper: GroupWrapper, enableRulesets: enableRulesets, renderInputs: renderInputs, formId: formId, formIndex: formIndex, SubWrapper: SubgroupWrapper, RepeatGroupWrapper: RepeatGroupWrapper, RepeatItemWrapper: RepeatItemWrapper, dispatchers: dispatchers }))))) : null;
const mapState = (state, props) => {
    const { id, index } = (0, selectors_1.useFormOrCurrent)(state, props);
    const { rex } = state;
    if (!props.derivedForm && !rex.forms[id]) {
        return {
            isReady: false,
            formId: id,
            formIndex: index,
            groups: [],
        };
    }
    return {
        isReady: true,
        formId: id,
        formIndex: index,
        groups: props.derivedForm ||
            (0, derive_form_1.deriveFormMemoLast)({
                groups: rex.forms[id][index].groups,
                models: rex.models[id],
                fusions: props.fusions,
                formId: id,
                formIndex: index,
            }),
    };
};
exports.default = (0, react_redux_1.connect)(mapState)(DynamicForm);
//# sourceMappingURL=DynamicForm.js.map